import React from "react";
import { Box, Button } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../store/store";
import { setCurrentMonth } from "../store/appSlice";
import { useTranslation } from "react-i18next";

const MonthSelector = () => {
  const { currentMonth } = useSelector((state: RootState) => state.app);
  const dispatch = useDispatch();
  const { t: tCommon } = useTranslation("common");

  const handlePrevMonth = () => {
    const newMonth = new Date(currentMonth);
    newMonth.setMonth(newMonth.getMonth() - 1);
    dispatch(setCurrentMonth(newMonth));
  };
  const handleNextMonth = () => {
    const newMonth = new Date(currentMonth);
    newMonth.setMonth(newMonth.getMonth() + 1);
    dispatch(setCurrentMonth(newMonth));
  };
  const onDateChange = (newDate: Date | null) => {
    if (newDate) {
      dispatch(setCurrentMonth(newDate));
    }
  };
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
        gap: 3,
        mb: 2,
      }}
    >
      <Button variant="contained" onClick={handlePrevMonth}>
        ＜
      </Button>
      <DatePicker
        label={tCommon("labels.yearMonth")}
        value={new Date(currentMonth)}
        onChange={onDateChange}
        format={tCommon("etc.format_ym")}
        views={["year", "month"]}
        slotProps={{
          calendarHeader: { format: `${tCommon("etc.format_ym")}` },
          toolbar: { hidden: true },
          actionBar: { actions: ["clear", "today"] },
        }}
      />
      <Button variant="contained" onClick={handleNextMonth}>
        ＞
      </Button>
    </Box>
  );
};

export default MonthSelector;
